export const SESSION_CLEAR_BROADCAST_KEY = "viridischem:client-session-cleared";

/** Notifies other tabs to clear active session state without deleting saved work. */
export const broadcastClientSessionClear = (): void => {
    try {
        window.localStorage.setItem(
            SESSION_CLEAR_BROADCAST_KEY,
            `${Date.now()}:${Math.random()}`
        );
    } catch {
        // Cross-tab notification must not block logout.
    }
};
